import { lazy } from 'react'
import { CSSProperties } from 'react'

interface LottieAnimationProps {
  animationData: any
  style?: CSSProperties
  loop?: boolean
  autoplay?: boolean
}

// Динамический импорт Lottie
const LottieComponent = lazy(() => import('lottie-react').then(module => ({
  default: ({ animationData, loop, autoplay, style }: LottieAnimationProps) => {
    const { View } = module.useLottie({
      animationData,
      loop,
      autoplay,
    })
    return <div style={style}>{View}</div>
  }
})))

export const LottieAnimation = (props: LottieAnimationProps) => {
  return (
      <LottieComponent {...props} />
  )
}